export const UspsWalletService = Object.freeze({
  FirstClassMail: '10',
  ParcelSelect: '12',
  PriorityMail: '13',
  PriorityMailExpressInternational: '15',
  // Global post services were originally part of USPS but later were broken out into separate carrier
  GlobalPostStandardIntl: '3251',
  GlobalPostPlus: '3511',
  GroundAdvantage: '3512',
});
